// @flow
import environment from '../../environment';

import type { Context, Middleware } from 'koa';

export const NO_REDIRECT_COOKIE_NAME = 'qempo:noredirect';
// Remove the dot com
const baseDomain = environment.baseUrl['US'].substring(0, environment.baseUrl['US'].length - 4);
export const domainRedirectMap = {
  US: `${baseDomain}.com`,
  PE: `${baseDomain}.com.pe`,
  CO: `${baseDomain}.com.co`,
  // TODO: We do not support these countries yet
  // MX: `${baseDomain}.com.mx`,
  // AR: `${baseDomain}.com.ar`,
  // CL: `${baseDomain}.cl`,
};

export const getCountryUpper = (ctx: Context): string => {
  const countryRaw = ctx.request.headers['cf-ipcountry'] || ctx.request.headers['x-origin-country'] || '';
  return countryRaw.toUpperCase();
};

export const redirectMiddleware: Middleware = async (ctx: Context, next: () => Promise<void>) => {
  const countryUpper = getCountryUpper(ctx);
  let ableToRedirect = true;
  /*console.log('countryUpper', countryUpper);*/

  if (ctx.query.noredirect === 'true') {
    ctx.cookies.set(NO_REDIRECT_COOKIE_NAME, 'true');
    ableToRedirect = false;
  }
  
  // console.log('redirectMiddleware => ableToRedirect: ', ableToRedirect);

  const host = ctx.headers.host || '';
  const requestUri = ctx.headers['x-original-request'] || '';

  if (ableToRedirect && ctx.cookies.get(NO_REDIRECT_COOKIE_NAME) !== 'true' && host.endsWith('.com') &&
    !!countryUpper && countryUpper !== 'US') {
    // NOTE: This depends on bought available domains
    if (Object.keys(domainRedirectMap).indexOf(countryUpper) !== -1) {
      return ctx.redirect(`${domainRedirectMap[countryUpper]}${requestUri}`);
    }
  }
  await next();
};



// WEBPACK FOOTER //
// ./src/server/middleware/redirect.js